import { defineStore } from "pinia";

export const useAlertStore = defineStore("alert", {
  persist: {
    paths: ["message"], // Only persist the message, not timeoutId
  },
  state: () => ({
    message: {
      title: null,
      body: null,
      linkName: null,
      linkValue: null,
      icon: null,
      isVisible: false,
    },
    timeoutId: null,
  }),
  actions: {
    setMessage(data) {
      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.message.title = data.title;
      this.message.body = data.body;
      this.message.linkName = data.linkName;
      this.message.linkValue = data.linkValue;
      this.message.icon = data.icon;
      this.message.isVisible = true;

      // Set auto-dismiss timeout if specified
      if (data.timeout && data.timeout > 0) {
        this.timeoutId = setTimeout(() => {
          this.message.isVisible = false;
          this.timeoutId = null;
        }, data.timeout);
      }
    },
    dismissMessage() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.message.isVisible = false;
    },
  },
  getters: {},
});
